import { render, staticRenderFns } from "./PanelBaseConfig.vue?vue&type=template&id=70f17846&"
import script from "./PanelBaseConfig.vue?vue&type=script&lang=js&"
export * from "./PanelBaseConfig.vue?vue&type=script&lang=js&"
import style0 from "./PanelBaseConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports